import PersonForm from "./PersonForm";
import AnimalInformationForm from "./AnimalInformationForm";
import ReservationOverview from "./ReservationOverview";
import {useState} from "react";
import AnimalNameInput from "./AnimalNameInput";
import VeterinaryForm from "./VeterinaryForm";
import NewReservationPlanner from "./NewReservationPlanner";
import EmergencyContactForm from "./EmergencyContact";
import {Grid} from "@mui/material";
import { useTenantConfig } from "../security/tenant-config-context";
import AppointmentServiceStep from "./appointment/AppointmentServiceStep";
import AppointmentTimeslotStep from "./appointment/AppointmentTimeslotStep";
import AppointmentOverview from "./appointment/AppointmentOverview";

function NewReservation() {
    const [currentStep, setCurrentStep] = useState(1);
    const { cfg } = useTenantConfig();
    const isAppointmentFlow = cfg?.businessTypes?.includes('APPOINTMENT_BASED');

    const updateCurrentStep = (step) => {
        setCurrentStep(step);
    };

    return (
        <div>
            <Grid container sx={{mt: 4}}>
                {!isAppointmentFlow && (
                    <>
                        {currentStep === 1 && (<AnimalNameInput updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 2 && (<NewReservationPlanner updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 3 && (<PersonForm updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 4 && (<VeterinaryForm updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 5 && (<AnimalInformationForm updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 6 && (<EmergencyContactForm updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 7 && (<ReservationOverview updateCurrentStep={updateCurrentStep}/>)}
                    </>
                )}
                {isAppointmentFlow && (
                    <>
                        {currentStep === 1 && (<AnimalNameInput updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 2 && (<AppointmentServiceStep updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 3 && (<AppointmentTimeslotStep updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 4 && (<PersonForm updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 5 && (<AnimalInformationForm updateCurrentStep={updateCurrentStep}/>)}
                        {currentStep === 6 && (<AppointmentOverview updateCurrentStep={updateCurrentStep}/>)}
                    </>
                )}
            </Grid>
        </div>
    )
}

export default NewReservation;
